import { Controller } from '@hotwired/stimulus'
import { stimulus } from '~/init'

export default class AnalyticsPeriodController extends Controller {
  static targets = ['dateRange', 'startDate', 'endDate']
  static values = { baseUrl: String }

  toggle () {
    this.dateRangeTarget.classList.toggle('hidden')
  }

  apply () {
    const start = this.startDateTarget.value
    const end = this.endDateTarget.value

    if (!start || !end) return

    // Convert from DD.MM.YYYY to YYYY-MM-DD for URL params
    const startDate = this.#parseDate(start)
    const endDate = this.#parseDate(end)

    if (!startDate || !endDate) return

    const url = new URL(this.baseUrlValue, window.location.origin)
    url.searchParams.set('period', 'custom')
    url.searchParams.set('start_date', startDate)
    url.searchParams.set('end_date', endDate)

    window.Turbo.visit(url.toString())
  }

  #parseDate (str) {
    // DD.MM.YYYY -> YYYY-MM-DD
    const parts = str.split('.')
    if (parts.length !== 3) return null
    return `${parts[2]}-${parts[1]}-${parts[0]}`
  }
}

stimulus.register('analytics-period', AnalyticsPeriodController)
